import React, { useState, useEffect, useContext } from "react";
import FadeIn from "react-fade-in";
import { GET_MINDFULNESS, GET_PAGE_TITLE } from "../../../../Routes.js";
import { generateURLOptions } from "../../../../URLOptions.js";
import axios from "axios";
import { UserContext } from "../../../../storage/contexts/UserContext.js";
import CommonMindfulnessItem from "../../../../InterstellrComponents/CommonMindfulnessItem.jsx";
import MindfulnessAudioPlayer from "../../../../InterstellrComponents/MindfulnessAudioPlayer.jsx";

const Mindfulness = () => {
  const { profile } = useContext(UserContext);

  const [pageTitle, setPageTitle] = useState("");
  const [mindfulness, setMindfulness] = useState([]);

  const [selectedAudio, setSelectedAudio] = useState(null);

  useEffect(() => {
    getPageTitle();
    getMindfulnessItems();
  }, []);

  const getPageTitle = async () => {
    await axios
      .get(GET_PAGE_TITLE + "mindfulness", {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        setPageTitle(response.data?.data?.heading ?? "");
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  const getMindfulnessItems = async () => {
    await axios
      .get(GET_MINDFULNESS, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        console.log("Mindfulness Data: ", response);
        setMindfulness(response.data?.data);
      })
      .catch((error) => {
        console.log("Get Exercise Category Data Error: ", error);
        return alert(error);
      });
  };

  return (
    <>
      <div
        className="w-screen min-h-screen"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <FadeIn delay={200}>
          <div className="container mx-auto flex flex-col justify-center items-center h-full w-full pb-24">
            <div className="mt-12 w-full px-6 md:px-0">
              <h4 className="text-xl md:text-2xl font-semibold">
                {pageTitle ? pageTitle : "Mindfulness"}
              </h4>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-2 md:gap-4 mt-2">
                {mindfulness?.map((item) => (
                  <CommonMindfulnessItem
                    key={item?._id}
                    item={item}
                    playing={selectedAudio?._id == item?._id}
                    onClick={(audio) => setSelectedAudio(audio)}
                  />
                ))}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
      <MindfulnessAudioPlayer audio={selectedAudio} />
    </>
  );
};

export default Mindfulness;
